import { render, staticRenderFns } from "./priceDetail.vue?vue&type=template&id=3a0bc2e1&scoped=true"
import script from "./priceDetail.vue?vue&type=script&lang=js"
export * from "./priceDetail.vue?vue&type=script&lang=js"
import style0 from "./priceDetail.vue?vue&type=style&index=0&id=3a0bc2e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0bc2e1",
  null
  
)

export default component.exports